import "core-js/modules/es.date.now.js";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import isEmpty from "lodash/isEmpty";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { isBrandOrderBackordered } from "../../utils/isBrandOrderBackordered";
import { CheckShipmentStatusCTA, GoToOrderDetailsCTA } from "./ctas";
import { NEED_MORE_INFO_ANSWER } from "./shared";
export var WhereIsMyOrderIA = function WhereIsMyOrderIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var _context$brandOrder;
  var selectedBrandOrder = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : _context$brandOrder.brand_order;
  var retailerShippingContext = context.shippingContext;
  if (!selectedBrandOrder || !retailerShippingContext) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  if (isBrandOrderBackordered(selectedBrandOrder)) {
    return BACKORDERED_ANSWER(strictLocalize);
  } else if (!isEmpty(retailerShippingContext.shipments)) {
    return TRACKING_AVAILABLE_ANSWER(strictLocalize);
  } else {
    var _retailerShippingCont, _retailerShippingCont2;
    var expectedShipDate = (_retailerShippingCont = (_retailerShippingCont2 = retailerShippingContext.expected_ship_window) === null || _retailerShippingCont2 === void 0 ? void 0 : _retailerShippingCont2.start_date) !== null && _retailerShippingCont !== void 0 ? _retailerShippingCont : retailerShippingContext.estimated_ship_date_upper_bound;
    return expectedShipDate && expectedShipDate > Date.now() ? SHIPMENT_ESTIMATE_ANSWER(strictLocalize, expectedShipDate) : NO_TRACKING_INFO_ANSWER(strictLocalize);
  }
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  var selectedBrandOrder = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.brand_order;
  var retailerShippingContext = context.shippingContext;
  if (!brandOrder || !selectedBrandOrder || !retailerShippingContext) {
    return undefined;
  }
  if (isBrandOrderBackordered(selectedBrandOrder)) {
    return GoToOrderDetailsCTA(strictLocalize);
  } else if (!isEmpty(retailerShippingContext.shipments)) {
    return CheckShipmentStatusCTA(strictLocalize);
  } else {
    return undefined;
  }
};
var TRACKING_AVAILABLE_ANSWER = function TRACKING_AVAILABLE_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ORDER_SHIPPED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CHECK_SHIPMENT_STATUS(strictLocalize)];
    }
  };
};
var BACKORDERED_ANSWER = function BACKORDERED_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ITEMS_BACKORDERED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [VISIT_ORDER_DETAILS(strictLocalize)];
    }
  };
};
var SHIPMENT_ESTIMATE_ANSWER = function SHIPMENT_ESTIMATE_ANSWER(strictLocalize, expectedShipDate) {
  return {
    getTitle: function getTitle() {
      return SHIPMENT_ESTIMATE(strictLocalize, expectedShipDate);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_FOR_ORDER_QUESTIONS(strictLocalize)];
    }
  };
};
var NO_TRACKING_INFO_ANSWER = function NO_TRACKING_INFO_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return TRACKING_INFO_UNAVAILABLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [NO_SHIPMENT_TRACKING_NUMBER(strictLocalize)];
    }
  };
};
var ORDER_SHIPPED = function ORDER_SHIPPED(strictLocalize) {
  return strictLocalize({
    id: "6II9k6",
    defaultMessage: [{
      "type": 0,
      "value": "Je bestelling is verzonden!"
    }]
  });
};
var CHECK_SHIPMENT_STATUS = function CHECK_SHIPMENT_STATUS(strictLocalize) {
  return strictLocalize({
    id: "zGYS4F",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt de verzendstatus van je bestelling controleren met behulp van onderstaande knop."
    }]
  });
};
var ITEMS_BACKORDERED = function ITEMS_BACKORDERED(strictLocalize) {
  return strictLocalize({
    id: "Yq3NLv",
    defaultMessage: [{
      "type": 0,
      "value": "Het merk heeft bepaalde of alle artikelen in je bestelling ingesteld als nabesteld"
    }]
  });
};
var VISIT_ORDER_DETAILS = function VISIT_ORDER_DETAILS(strictLocalize) {
  return strictLocalize({
    id: "oFXVSh",
    defaultMessage: [{
      "type": 0,
      "value": "Bezoek de pagina Bestelgegevens voor meer informatie."
    }]
  });
};
var SHIPMENT_ESTIMATE = function SHIPMENT_ESTIMATE(strictLocalize, expectedShipDate) {
  return strictLocalize({
    id: "JQAoR4",
    defaultMessage: [{
      "type": 0,
      "value": "Je bestelling wordt naar verwachting verzonden op "
    }, {
      "type": 1,
      "value": "expectedShipDate"
    }]
  }, {
    expectedShipDate: expectedShipDate ? intlDate(expectedShipDate, "PP") : "(unknown)"
  });
};
var MESSAGE_BRAND_FOR_ORDER_QUESTIONS = function MESSAGE_BRAND_FOR_ORDER_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "nq82Ud",
    defaultMessage: [{
      "type": 0,
      "value": "Als je in de tussentijd vragen hebt over je bestelling, stuur dan een bericht naar het merk door op onderstaande knop te klikken of neem contact met ons op als je meer hulp nodig hebt."
    }]
  });
};
var TRACKING_INFO_UNAVAILABLE = function TRACKING_INFO_UNAVAILABLE(strictLocalize) {
  return strictLocalize({
    id: "dMwj9t",
    defaultMessage: [{
      "type": 0,
      "value": "Trackinginformatie is niet beschikbaar"
    }]
  });
};
var NO_SHIPMENT_TRACKING_NUMBER = function NO_SHIPMENT_TRACKING_NUMBER(strictLocalize) {
  return strictLocalize({
    id: "DuC0OF",
    defaultMessage: [{
      "type": 0,
      "value": "Het merk heeft geen trackingnummer voor de zending opgegeven. Dit kan zijn omdat het artikel nog niet is verzonden. Stuur een bericht naar het merk door op de onderstaande knop te klikken of neem contact met ons op als je meer hulp nodig hebt."
    }]
  });
};